import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSectionTranslation } from '@/hooks';
import { useLocale } from '@/lib/i18n';
import { sellerTrustTranslations } from './translations';

export function SellerTrust() {
  const t = useSectionTranslation(sellerTrustTranslations);
  const { direction } = useLocale();
  const isRTL = direction === 'rtl';

  return (
    <section className="py-10 md:py-14">
      <div className="container-main">
        <div className="relative overflow-hidden rounded-2xl border border-accent/20 bg-surface-card px-6 py-8 md:px-10">
          <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <h2 className="font-display text-display-md text-brand-white">
              {t.headline}
            </h2>
            <Link to="/seller" className="group btn-primary h-11 shrink-0 self-start md:self-center">
              {t.cta}
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
                style={{ transform: isRTL ? 'scaleX(-1)' : undefined }}
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
